import { fetchData } from 'Utils/fetch-data';
import type { CourseApprovalPayloadI } from 'types';

/**
 * Aprobación de cursos.
 *
 * Vive en su propio cliente y no en el de empleados porque la operación es
 * sobre un curso: aprueba a varios empleados a la vez, y el `courseId` de la
 * ruta es lo que permite al servidor validar que toda la lista le pertenece.
 */
class CourseApprovalsApi {
  /** `POST /courses/:courseId/approvals` */
  async approve(courseId: string, payload: CourseApprovalPayloadI) {
    return fetchData<{ approved: number; userCourseIds: string[] }>(`/courses/${courseId}/approvals`, {
      method: 'POST',
      data: payload,
    });
  }
}

export const courseApprovalsApi = new CourseApprovalsApi();

export default courseApprovalsApi;
